import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ExportIcon from '@material-ui/icons/SaveAlt';
import Button from '../../../_ui/Button/Button';
import { exportDataContingent, monitoringModule } from '../MonitoringDucks';

export default function ExportFile({ filter }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const loadingExport = useSelector(state => state[monitoringModule].loadingExport);

  return (
    <Button
      loading={loadingExport}
      text={t('monitoring_export_btn')}
      icon={<ExportIcon fontSize="small" className="mr1" />}
      onClick={() => dispatch(exportDataContingent(filter))}
    />
  );
}
